/* eslint-disable @cspell/spellchecker */
import {
  artemisTestingOrganization,
  auditOnPlatformDevOrganization,
} from '../test-organizations';
import { getLaunchpadUsers } from './test-user-base-info';

export const devInternalControlsTestUsers = getLaunchpadUsers([
  {
    email: 'bsimandi@diligent.com',
    name: 'Barbara Simandi',
    highbondId: '_WxU4MGd2GfnT939Uu83',
    id: '5CED69C8-9921-41BD-9E3B-40EECB3BFB01',
    organization: artemisTestingOrganization,
    secondaryOrganizations: [auditOnPlatformDevOrganization],
  },
  {
    email: 'bkiss@diligent.com',
    name: 'Bence Kiss',
    highbondId: 'LLxkeCGxFy6yix9jiNqM',
    id: '5CED69C8-9921-41BD-9E3B-40EECB3BFB02',
    organization: artemisTestingOrganization,
    secondaryOrganizations: [auditOnPlatformDevOrganization],
  },
  {
    email: 'kkurtisz@diligent.com',
    name: 'Krisztian Kurtisz',
    highbondId: 'yB5QPRDkTXY_wAtjx3Lf',
    id: '5CED69C8-9921-41BD-9E3B-40EECB3BFB03',
    organization: artemisTestingOrganization,
    secondaryOrganizations: [auditOnPlatformDevOrganization],
  },
  {
    email: 'lcsadi@diligent.com',
    name: 'László Csadi',
    highbondId: 'txcEAsNBsyaSLgGwxSee',
    id: '5CED69C8-9921-41BD-9E3B-40EECB3BFB04',
    organization: artemisTestingOrganization,
    secondaryOrganizations: [auditOnPlatformDevOrganization],
  },
  {
    email: 'pshetty@diligent.com',
    name: 'Pooja Shetty',
    highbondId: 'd_znQbaGt5ijXwcypZm5',
    id: '5CED69C8-9921-41BD-9E3B-40EECB3BFB05',
    organization: artemisTestingOrganization,
    secondaryOrganizations: [auditOnPlatformDevOrganization],
  },
  {
    email: 'pcsoor@diligent.com',
    name: 'Peter Csoor',
    highbondId: 'vT_8n3rDW54833Z-SykT',
    id: '5CED69C8-9921-41BD-9E3B-40EECB3BFB06',
    organization: artemisTestingOrganization,
    secondaryOrganizations: [auditOnPlatformDevOrganization],
  },
  {
    email: 'zsomolnar@diligent.com',
    name: 'Zsolt Molnar',
    highbondId: 'QCxe-RRyoMxzX-PLdCa8',
    id: '5CED69C8-9921-41BD-9E3B-40EECB3BFB07',
    organization: artemisTestingOrganization,
    secondaryOrganizations: [auditOnPlatformDevOrganization],
  },
  {
    email: 'kpakozdi@diligent.com',
    name: 'Karoly Pákozdi',
    highbondId: '35rJCfyooJTKpD4u9RkF',
    id: '5CED69C8-9921-41BD-9E3B-40EECB3BFB08',
    organization: artemisTestingOrganization,
    secondaryOrganizations: [auditOnPlatformDevOrganization],
  },
  {
    email: 'bkeve@diligent.com',
    name: 'Botond Keve',
    highbondId: '6yxGb5DUyYLuzjMr1voc',
    id: '5CED69C8-9921-41BD-9E3B-40EECB3BFB09',
    organization: artemisTestingOrganization,
    secondaryOrganizations: [auditOnPlatformDevOrganization],
  },
  {
    email: 'bavarga@diligent.com',
    name: 'Balazs Varga',
    highbondId: 'Xvs76UNNcXD9n2stsY22',
    id: '5CED69C8-9921-41BD-9E3B-40EECB3BFB10',
    organization: artemisTestingOrganization,
    secondaryOrganizations: [auditOnPlatformDevOrganization],
  },
  {
    email: 'zlevai@diligent.com',
    name: 'Zoltán Lévai',
    highbondId: 'ccpgJuFa4c1BFsJoyxK5',
    id: '5CED69C8-9921-41BD-9E3B-40EECB3BFB11',
    organization: artemisTestingOrganization,
    secondaryOrganizations: [auditOnPlatformDevOrganization],
  },
  {
    email: 'fsipka@diligent.com',
    password: 'asdQWE123',
    name: 'Fruzsina Sipka',
    highbondId: 'gFu6y_W6xwgsJkLMV9pT',
    id: '5CED69C8-9921-41BD-9E3B-40EECB3BFB12',
    organization: artemisTestingOrganization,
    secondaryOrganizations: [auditOnPlatformDevOrganization],
  },
  {
    email: 'tferenczi@diligent.com',
    name: 'Timea Ferenczi',
    highbondId: 'kyH-vp6UPVXcuwzGvz-b',
    id: '5CED69C8-9921-41BD-9E3B-40EECB3BFB13',
    organization: artemisTestingOrganization,
    secondaryOrganizations: [auditOnPlatformDevOrganization],
  },
]);
